import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'motn-banner',
  template: `
    <div
      class="banner"
      [attr.data-color]="bkgdColor"
    >
      <i
        [ngClass]="['fa-solid', 'fa-'+icon]"
      ></i>

      <div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class BannerComponent {
  @Input() icon: string = 'info-circle';
  @Input() bkgdColor: 'blue' | 'green' | 'white' = 'white';


  constructor() {
  }
}
